const parse = (qs) => {
  return Object.fromEntries(new URLSearchParams(qs))
}

const stringify = (object) => {
  return new URLSearchParams(object).toString()
}

export default { parse, stringify }
